import { render, staticRenderFns } from "./realPowerQuality.vue?vue&type=template&id=27db3f6c&scoped=true&"
import script from "./realPowerQuality.vue?vue&type=script&lang=js&"
export * from "./realPowerQuality.vue?vue&type=script&lang=js&"
import style0 from "./realPowerQuality.vue?vue&type=style&index=0&id=27db3f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db3f6c",
  null
  
)

export default component.exports